<template>

	<div class="image-input">
		<span class="label">
			{{ label }}
			<span class="subtitle" v-if="subtitle">{{ subtitle }}</span>
		</span>
		<label :for="name">
			Upload foto
		</label>

		<div v-if="imageUrl" class="image-preview">
			<div class="image-preview__datawrapper">
				<div class="image-preview__img">
					<img :src="imageUrl"/>
				</div>
				<div class="image-preview__data">
					<span class="image-name">{{ value ?. name }}</span>
					<span class="image-size"></span>
				</div>
			</div>
			<div class="image-preview__close">
				<button type="button" @click="value = null" class="image-preview__delete"><svg width="12" height="10" viewBox="0 0 12 10" xmlns="http://www.w3.org/2000/svg"><path d="M1 10 11 0M1 0l10 10" stroke="#374151" fill="none" fill-rule="evenodd" stroke-linecap="round" stroke-linejoin="round"/></svg></button>
			</div>
		</div>

		<input
			ref="input"
			type="file"
			accept="image/*"
			@change="evt => changePhoto(evt)"
			:id="name"
			hidden
		/>


	</div>
</template>

<script>


function dataUriFromFormField (field) {
	return new Promise((resolve) => {
		const reader = new FileReader();

		reader.addEventListener('load', () => {
			resolve(reader.result);
		});

		reader.readAsDataURL(field);
	});
}

function resizeImage(imgEl, wantedWidth, wantedHeight) {
	const canvas = document.createElement('canvas');
	const ctx = canvas.getContext('2d');

	const widthRatio = wantedWidth / imgEl.width;
	const heightRatio = wantedHeight / imgEl.height;

	const ratio = (widthRatio + heightRatio) / 2;

	canvas.width = imgEl.width * ratio;
	canvas.height = imgEl.height * ratio;

	ctx.drawImage(imgEl, 0, 0, canvas.width, canvas.height);
	return canvas.toDataURL('image/jpeg', 95);
}

function resizeImageFromDataUri(dataUri, toWidth, toHeight){
	return new Promise((resolve, reject) => {
		const img = document.createElement('img');
		img.addEventListener('load', () => {
			const resizedDataUri = resizeImage(img, toWidth, toHeight);
			resolve(resizedDataUri);
		});
		img.src = dataUri;
	});

}


export default {
	name: "ImageInput",
	props: {
		label: {},
		modelValue: {},
		name: '',
		subtitle: null,
	},
	data() {
		return {
			value: {},
		};
	},
	created() {
		this.value = this.modelValue;
	},
	methods: {

		async changePhoto(evt) {

			evt.preventDefault();
			evt.stopPropagation();

			const file = this.$refs.input.files[0];

			if(!file){
				this.value = null;
				return;
			}

			const dataUri = await dataUriFromFormField(file);

			this.value = {
				image: await resizeImageFromDataUri(dataUri, 1250, 940),
				name: file.name,
			};

			return false;

		},

	},

  computed: {
    imageUrl(){
      if(typeof this.value == 'string'){
        return this.value;
      }
      return this.value?.image;
    }
  },

	watch: {
		value(val){
			console.log('ImageInput::watch.value');
			this.$emit('update:modelValue', val)
		}
	}
}
</script>

<style scoped>
	.image-input {
		margin-bottom: 32px;
	}

	label {
		text-align: center;
		font-size: 16px;
		font-weight: bold;
		border-radius: 10px;
		background-color: #10303d;
		color: white;
		padding: 18px 14px 14px;
	}

	.image-preview {
		display: flex;
		align-items: center;
		justify-content: space-between;
		padding: 10px 16px 10px 10px;
		border-radius: 7px;
		border: solid 1px #dadde2;
	}

	.image-preview__datawrapper {
		display: flex;
		align-items: center;
	}

	.image-preview__img {
		width: 70px;
		height: 60px;
		border-radius: 7px;
		border: solid 1px #dadde2;
		background-color: #f5f5f7;
		margin-right: 12px;
	}

	.image-preview__img img {
		object-fit: cover;
		width: 100%;
		height: 100%;
	}

	.image-name{
		opacity: 0.8;
		font-size: 1.4rem;
		line-height: 1.43;
	}

	.image-preview__delete {
		background: transparent;
		border: 0;
		appearance: none;
	}
</style>